import { Component } from '@angular/core';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrl: './report-header.component.css',
  standalone: false
})
export class ReportHeaderComponent {
  isCategoryReport: boolean = false;
  isUserReport: boolean = false;
  
}
